import { IRoute } from "../../../common/helpers/routesMapper";
import { connect } from "react-redux";
import withRouter from "../../utils/withRouter";
import injectIntl from "../../../common/helpers/injectIntl";

import { seo } from "../../../common/helpers/seo";

import { post, get } from "../../actions/general";
import { getPacks, createPack, deletePack } from "../../store/dashboard/actions";
import { IStateTree } from "../../store/interfaces";

import lazyComponent from "./lazy";
import { Store } from "redux";
import { IUser } from "../../store/user/models";

const mapStateToProps = (state: IStateTree) => ({
    user: state.user as IUser,
    packs: state.packs.packs,
    isPackLoading: !!state.packs.loading,
    isPackError: !!state.packs.error,
});

export default {
    component: withRouter(
        connect(mapStateToProps, { post, get, getPacks, createPack, deletePack })(
            injectIntl(lazyComponent)
        )
    ),
    renderSeo: (store: Store, allMessage: {[key: string]: string}, lang: string) => {
        return seo({ title: allMessage["menu.editor"], allMessage, lang });
    },
} satisfies IRoute;
